let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6YVGh")).then(() => parcelRequire('lns8o'));